import { ImageList } from '../../../shared';

import * as sputter0 from './0.jpg';
import * as sputter1 from './1.jpg';
import * as sputter2 from './2.jpg';

export const sputterImages: ImageList = [
    {
        caption: 'Chamber',
        src: sputter0.default,
    },
    {
        caption: 'Setup',
        src: sputter1.default,
    },
    {
        caption: 'Magnetron Plasma',
        src: sputter2.default,
    },
];
